/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import Cookies from 'js-cookie';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { Header, Sidebar } from '../components';
import { SESSION_EXPIRE_TIME } from '../constants/Config';
import {
  ALL_FILE_ROUTE,
  CGA_FILE_ROUTE,
  DASHBOARD_ROUTE,
  EDITOR_ROUTE,
  MY_FILE_ROUTE,
  PERSONAL_INFORMATION_ROUTE,
  VENDORS_ROUTE,
} from '../constants/RouteNameConstants';
import Dashboard from '../modules/authorization/Dashboard/component/Dashboard';
import {
  checkForceUnclaimReset,
  resetAllSpeakrsData,
  resetEditorData,
  resetEditorDocumentData,
  resetVendorNextTranscript,
} from '../modules/authorization/Editor/actions';
import EditorPage from '../modules/authorization/Editor/component/Editor';
import AllFiles from '../modules/authorization/Files/AllFiles/component/AllFiles';
import MyFiles from '../modules/authorization/Files/MyFiles/component/MyFiles';
import PersonalInformation from '../modules/authorization/PersonalInformation/PersonalInformation';
import Vendors from '../modules/authorization/Vendors/component/Vendors';
import NotFoundPage from '../NotFoundPage';
import { getUserInfo } from '../utils/UserInfoUtils';
import { UserLogout } from '../utils/UserLogout';
import EditorCopy from '../modules/authorization/Editor-Copy/components/Editor-Copy';
import { resetEditorState, updateSlateIsClaim } from '../modules/authorization/Editor-Copy/actions/slateDataActions';
import { resetGlossaryState } from '../modules/authorization/Editor-Copy/actions/glossaryActions';
import CGAFiles from '../modules/authorization/Files/CGAFiles/component/CgaFiles';

const Layout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const userInfo = getUserInfo();
  const dispatch = useDispatch();
  const [fullQcClick, setFullQcClick] = useState(false);
  const [qcClick, setQcClick] = useState(false);
  const [dueInDayClick, setDueInDayClick] = useState(false);
  const [dueInHalfDayClick, setDueInHalfDayClick] = useState(false);
  const [legalClick, setLegalClick] = useState(false);
  const [todayWorkClick, setTodayWorkClick] = useState(false);
  const [isRefreshed, setIsRefreshed] = useState(false);
  const [filterClientData, setFilterClientData] = useState('');
  const [filterVendorData, setFilterVendorData] = useState('');
  const [filterLanguageData, setFilterLanguageData] = useState('');
  const [filterServiceData, setFilterServiceData] = useState('');
  const [proofReaderAllFileFilterModal, setProofReaderAllFileFilterModal] = useState(false);
  const [filterApiCall, setFilterApiCall] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [filterVendorLanguageData, setFilterVendorLanguageData] = useState(0);
  const [filterVendorClientData, setFilterVendorClientData] = useState(null);
  const [filterStatusData, setFilterStatusData] = useState(0);
  const [filterGroupData, setFilterGroupData] = useState('');
  const [filterRatingData, setFilterRatingData] = useState(0);
  const [filterFilesStatusData, setFilterFilesStatusData] = useState([]);
  const [dashboardClick, setDashboardClick] = useState(false);
  const isSaveTranscriptInProgressRef = useRef(0);
  const isTempSaveTranscript = useRef(2);
  const [claimFile, setClaimFile] = useState(false);
  const allSpeakersRef = useRef(null);

  const [cookieValue, setCookieValue] = useState(() => {
    const cookie = Cookies.get('userDataProofreader');
    return cookie ? JSON.parse(cookie) : null;
  });
  useEffect(() => {
    dispatch(updateSlateIsClaim(claimFile));
  }, [claimFile]);

  useEffect(() => {
    const interval = setInterval(() => {
      const cookie = Cookies.get('userDataProofreader');
      const currentCookieValue = cookie ? JSON.parse(cookie) : null;

      // Check for any change in the cookie data
      if (JSON.stringify(cookieValue) !== JSON.stringify(currentCookieValue)) {
        setCookieValue(currentCookieValue); // Update state
        if (currentCookieValue) {
          window.location.href = DASHBOARD_ROUTE; // Redirect to dashboard
        }
      }
    }, 1000); // Check every second

    return () => clearInterval(interval); // Cleanup on unmount
  }, [cookieValue, navigate]);

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when location changes
  }, [location.pathname]);

  const determineActiveKey = (pathname) => {
    if (pathname === DASHBOARD_ROUTE) return '0';
    if (pathname === VENDORS_ROUTE) return '2';
    if (pathname === PERSONAL_INFORMATION_ROUTE) return '3';
    if (pathname.includes('/files')) return '1';
    return '0';
  };

  // Initialize state based on current pathname
  const [activeKeyNew, setActiveKeyNew] = useState(determineActiveKey(location.pathname));

  useEffect(() => {
    setActiveKeyNew(determineActiveKey(location.pathname));
  }, [location.pathname]);

  useEffect(() => {
    // Check if the current pathname includes '/editor'
    if (!location?.pathname?.includes('/editor')) {
      dispatch(resetEditorData());
      dispatch(resetAllSpeakrsData());
      allSpeakersRef.current = null;
      dispatch(resetEditorDocumentData());
      dispatch(resetVendorNextTranscript());
      isSaveTranscriptInProgressRef.current = 0;
      isTempSaveTranscript.current = 2;
    }
    // Dispatch the action to reset the dashboardWidgetData in the store
    dispatch(checkForceUnclaimReset());
  }, [location, dispatch]); // Effect runs whenever the route changes

  useEffect(() => {
    if (sessionStorage.length > 0) {
      const pageWasRefreshed = sessionStorage.getItem('wasRefreshedProofreader');
      if (pageWasRefreshed) {
        setIsRefreshed(true);
      } else {
        setIsRefreshed(false);
      }
    } else {
      sessionStorage.setItem('wasRefreshedProofreader', 'true');
    }
  }, []);

  const usePreviousPath = () => {
    const location = useLocation();
    const previousPath = useRef(location.pathname);

    useEffect(() => {
      previousPath.current = location.pathname;
    }, [location.pathname]);

    return previousPath.current;
  };

  useEffect(() => {
    if (userInfo === null) {
      UserLogout();
    }
  }, [location, userInfo]);

  const isComingFromDashboard = usePreviousPath() === DASHBOARD_ROUTE;

  const [isSessionExpiredModalVisible, setIsSessionExpiredModalVisible] = useState(false); // Modal visibility state

  // Timer reference to clear and reset the inactivity timer
  let inactivityTimerRef = useRef(null);

  // Function to reset the inactivity timer
  const resetInactivityTimer = useCallback(() => {
    if (inactivityTimerRef.current) clearTimeout(inactivityTimerRef.current); // Clear the existing timer

    // Set a new timer for inactivity (default: 60 minutes)
    inactivityTimerRef.current = setTimeout(() => {
      setIsSessionExpiredModalVisible(true); // Show the modal after timeout
    }, SESSION_EXPIRE_TIME);
  }, []);

  // Register event listeners for user activity
  useEffect(() => {
    const events = ['mousedown', 'keydown', 'scroll', 'wheel', 'mousemove'];

    // Reset the inactivity timer on any user activity
    const resetOnActivity = () => resetInactivityTimer();

    // Attach event listeners to detect user activity
    events.forEach((event) => window.addEventListener(event, resetOnActivity));

    // Start the inactivity timer when the component mounts
    resetInactivityTimer();

    // Cleanup: Remove event listeners and clear the timer when unmounted
    return () => {
      events.forEach((event) => window.removeEventListener(event, resetOnActivity));
      if (inactivityTimerRef.current) clearTimeout(inactivityTimerRef.current);
    };
  }, [resetInactivityTimer]);

  useEffect(() => {
    if (isSessionExpiredModalVisible) {
      Cookies.set('sessionExpireModalOpenProofreader', 'true');
    }
  }, [isSessionExpiredModalVisible]);

  // Handle closing the modal
  const handleSessionExpiredOkClick = () => {
    UserLogout();
  };

  useEffect(() => {
    if (Cookies.get('sessionExpireModalOpenProofreader') === 'true' && isRefreshed) {
      handleSessionExpiredOkClick();
      Cookies.remove('sessionExpireModalOpenProofreader');
    }
  }, [isRefreshed, Cookies.get('sessionExpireModalOpenProofreader')]);

  const handleCloseProofReaderAllFileFilter = () => {
    setProofReaderAllFileFilterModal(false);
  };

  const handleFilterClear = () => {
    setFilterApiCall(true);
    setFilterClientData('');
    setFilterVendorData('');
    setFilterLanguageData('');
    setFilterServiceData('');
    handleCloseProofReaderAllFileFilter();
    setCurrentPage(0);
    setFilterFilesStatusData([]);
  };

  const handleFilter = () => {
    handleCloseProofReaderAllFileFilter();
    setFilterApiCall(true);
    setCurrentPage(0);
  };

  const handleCloseProofReaderVendorFileFilter = () => {
    setProofReaderAllFileFilterModal(false);
  };

  const handleVendorFilterClear = () => {
    setFilterApiCall(true);
    setFilterStatusData(0);
    setFilterVendorLanguageData(0);
    setFilterGroupData('');
    setFilterRatingData(0);
    setFilterVendorClientData(null);
    handleCloseProofReaderVendorFileFilter();
    setCurrentPage(0);
  };

  const handleVendorFilter = () => {
    handleCloseProofReaderVendorFileFilter();
    setFilterApiCall(true);
    setCurrentPage(0);
  };

  useEffect(() => {
    if (!location.pathname.includes('/editor-copy')) {
      dispatch(resetEditorState());
      dispatch(resetGlossaryState());
    }
  }, [location.pathname]);

  const isFilterApplied =
    filterClientData !== '' ||
    filterVendorData !== '' ||
    filterLanguageData !== '' ||
    filterServiceData ||
    filterFilesStatusData?.length !== 0;

  return (
    <span>
      {location.pathname.includes('/editor/') || location.pathname.includes('/editor-copy/') ? (
        <div id="wrapper">
          <div id="content-wrapper" className="d-flex flex-column">
            <div id="content">
              <Header
                isSaveTranscriptInProgressRef={isSaveTranscriptInProgressRef}
                isTempSaveTranscript={isTempSaveTranscript}
                setFullQcClick={setFullQcClick}
                setQcClick={setQcClick}
                setDueInDayClick={setDueInDayClick}
                setDueInHalfDayClick={setDueInHalfDayClick}
                setLegalClick={setLegalClick}
                handleFilterClear={handleFilterClear}
                setDashboardClick={setDashboardClick}
                setClaimFile={setClaimFile}
                claimFile={claimFile}
                allSpeakersRef={allSpeakersRef}
              />
              <Routes>
                <Route
                  path={EDITOR_ROUTE}
                  element={
                    <EditorPage
                      usePreviousPath={isComingFromDashboard}
                      todayWorkClick={todayWorkClick}
                      setTodayWorkClick={setTodayWorkClick}
                      isSaveTranscriptInProgressRef={isSaveTranscriptInProgressRef}
                      isTempSaveTranscript={isTempSaveTranscript}
                      handleFilterClear={handleFilterClear}
                      setFullQcClick={setFullQcClick}
                      setQcClick={setQcClick}
                      setDueInDayClick={setDueInDayClick}
                      setDueInHalfDayClick={setDueInHalfDayClick}
                      setLegalClick={setLegalClick}
                      setDashboardClick={setDashboardClick}
                      claimFile={claimFile}
                      allSpeakersRef={allSpeakersRef}
                    />
                  }
                />
                <Route
                  path={`/editor-copy/:id`}
                  element={
                    <EditorCopy
                      usePreviousPath={isComingFromDashboard}
                      todayWorkClick={todayWorkClick}
                      setTodayWorkClick={setTodayWorkClick}
                      claimFile={claimFile}
                      isSaveTranscriptInProgressRef={isSaveTranscriptInProgressRef}
                      setFilterApiCall={setFilterApiCall}
                    />
                  }
                />
              </Routes>
            </div>
          </div>
        </div>
      ) : (
        <div id="wrapper">
          <Sidebar
            setDueInHalfDayClick={setDueInHalfDayClick}
            setDueInDayClick={setDueInDayClick}
            setFullQcClick={setFullQcClick}
            setQcClick={setQcClick}
            setLegalClick={setLegalClick}
            activeKeyNew={activeKeyNew}
            handleFilterClear={handleFilterClear}
            handleVendorFilterClear={handleVendorFilterClear}
            setDashboardClick={setDashboardClick}
          />
          <div id="content-wrapper" className="d-flex flex-column">
            <div id="content">
              <Header
                setFullQcClick={setFullQcClick}
                setQcClick={setQcClick}
                setDueInDayClick={setDueInDayClick}
                setDueInHalfDayClick={setDueInHalfDayClick}
                setLegalClick={setLegalClick}
                handleFilterClear={handleFilterClear}
                setClaimFile={setClaimFile}
              />
              <div className="container-fluid">
                <main className="content">
                  <div className="mainContent">
                    <Routes>
                      <Route
                        path={DASHBOARD_ROUTE}
                        element={
                          <Dashboard
                            setDueInHalfDayClick={setDueInHalfDayClick}
                            setDueInDayClick={setDueInDayClick}
                            setFullQcClick={setFullQcClick}
                            setQcClick={setQcClick}
                            setLegalClick={setLegalClick}
                            filterClientData={filterClientData}
                            setFilterClientData={setFilterClientData}
                            filterVendorData={filterVendorData}
                            setFilterVendorData={setFilterVendorData}
                            filterLanguageData={filterLanguageData}
                            setFilterLanguageData={setFilterLanguageData}
                            filterServiceData={filterServiceData}
                            setFilterServiceData={setFilterServiceData}
                            handleFilter={handleFilter}
                            handleFilterClear={handleFilterClear}
                            handleCloseProofReaderAllFileFilter={handleCloseProofReaderAllFileFilter}
                            setProofReaderAllFileFilterModal={setProofReaderAllFileFilterModal}
                            proofReaderAllFileFilterModal={proofReaderAllFileFilterModal}
                            filterApiCall={filterApiCall}
                            setFilterApiCall={setFilterApiCall}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            setDashboardClick={setDashboardClick}
                            dashboardClick={dashboardClick}
                            setClaimFile={setClaimFile}
                            setFilterFilesStatusData={setFilterFilesStatusData}
                            filterFilesStatusData={filterFilesStatusData}
                            isFilterApplied={isFilterApplied}
                          />
                        }
                      />
                      <Route
                        path={ALL_FILE_ROUTE}
                        element={
                          <AllFiles
                            dueInDayClick={dueInDayClick}
                            fullQcClick={fullQcClick}
                            qcClick={qcClick}
                            legalClick={legalClick}
                            setFullQcClick={setFullQcClick}
                            setQcClick={setQcClick}
                            setDueInDayClick={setDueInDayClick}
                            setDueInHalfDayClick={setDueInHalfDayClick}
                            setLegalClick={setLegalClick}
                            filterClientData={filterClientData}
                            setFilterClientData={setFilterClientData}
                            filterVendorData={filterVendorData}
                            setFilterVendorData={setFilterVendorData}
                            filterLanguageData={filterLanguageData}
                            setFilterLanguageData={setFilterLanguageData}
                            filterServiceData={filterServiceData}
                            setFilterServiceData={setFilterServiceData}
                            handleFilter={handleFilter}
                            handleFilterClear={handleFilterClear}
                            handleCloseProofReaderAllFileFilter={handleCloseProofReaderAllFileFilter}
                            setProofReaderAllFileFilterModal={setProofReaderAllFileFilterModal}
                            proofReaderAllFileFilterModal={proofReaderAllFileFilterModal}
                            filterApiCall={filterApiCall}
                            setFilterApiCall={setFilterApiCall}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            setClaimFile={setClaimFile}
                            filterFilesStatusData={filterFilesStatusData}
                            setFilterFilesStatusData={setFilterFilesStatusData}
                            isFilterApplied={isFilterApplied}
                          />
                        }
                      />
                      <Route
                        path={MY_FILE_ROUTE}
                        element={
                          <MyFiles
                            dueInHalfDayClick={dueInHalfDayClick}
                            filterClientData={filterClientData}
                            setFilterClientData={setFilterClientData}
                            filterVendorData={filterVendorData}
                            setFilterVendorData={setFilterVendorData}
                            filterLanguageData={filterLanguageData}
                            setFilterLanguageData={setFilterLanguageData}
                            filterServiceData={filterServiceData}
                            setFilterServiceData={setFilterServiceData}
                            handleFilter={handleFilter}
                            handleFilterClear={handleFilterClear}
                            handleCloseProofReaderAllFileFilter={handleCloseProofReaderAllFileFilter}
                            setProofReaderAllFileFilterModal={setProofReaderAllFileFilterModal}
                            proofReaderAllFileFilterModal={proofReaderAllFileFilterModal}
                            filterApiCall={filterApiCall}
                            setFilterApiCall={setFilterApiCall}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            setClaimFile={setClaimFile}
                            setFilterFilesStatusData={setFilterFilesStatusData}
                            filterFilesStatusData={filterFilesStatusData}
                            isFilterApplied={isFilterApplied}
                          />
                        }
                      />
                      <Route
                        path={CGA_FILE_ROUTE}
                        element={
                          <CGAFiles />
                        }
                      />
                      <Route
                        path={VENDORS_ROUTE}
                        element={
                          <Vendors
                            handleCloseProofReaderVendorFileFilter={handleCloseProofReaderVendorFileFilter}
                            handleVendorFilterClear={handleVendorFilterClear}
                            handleVendorFilter={handleVendorFilter}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            proofReaderAllFileFilterModal={proofReaderAllFileFilterModal}
                            setProofReaderAllFileFilterModal={setProofReaderAllFileFilterModal}
                            filterStatusData={filterStatusData}
                            setFilterStatusData={setFilterStatusData}
                            filterVendorLanguageData={filterVendorLanguageData}
                            setFilterVendorLanguageData={setFilterVendorLanguageData}
                            filterGroupData={filterGroupData}
                            setFilterGroupData={setFilterGroupData}
                            filterRatingData={filterRatingData}
                            setFilterRatingData={setFilterRatingData}
                            filterVendorClientData={filterVendorClientData}
                            setFilterVendorClientData={setFilterVendorClientData}
                            filterApiCall={filterApiCall}
                            setFilterApiCall={setFilterApiCall}
                          />
                        }
                      />
                      <Route path={PERSONAL_INFORMATION_ROUTE} element={<PersonalInformation />} />
                      <Route path="*" element={<NotFoundPage />} />
                    </Routes>
                  </div>
                </main>
              </div>
            </div>
          </div>
        </div>
      )}
      <Modal
        show={isSessionExpiredModalVisible}
        onHide={handleSessionExpiredOkClick}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="custom-modal"
      >
        <div className="preview-dropdown-body my-4">
          <div className="text-center fw-medium fs-4" id="SessionExpired">
            Session Expired
          </div>
          <div className="text-center mt-3 mb-4">
            Since you've been inactive for 60 minutes, We're going to log you out to keep your account safe.
          </div>
          <div className="text-center">
            <Button variant="primary" onClick={handleSessionExpiredOkClick}>
              OK
            </Button>
          </div>
        </div>
      </Modal>
    </span>
  );
};

export default Layout;
